import styled from 'styled-components';

export const ShopItemsContainer = styled.div`
    width: 100%;
    height: 100%;
    padding: 100px 0px 0px 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

export const SearchBar= styled.input`
    width: 100%;
    height: 40px; 
    background: linear-gradient(303.77deg, #2C333A -71.57%, #1C1E22 59.28%, #121416 59.28%);
    box-shadow: inset -2px -2px 10px rgba(255, 255, 255, 0.05), inset 2px 3px 10px #070709;
    border-radius: 12px;
    border: none;
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 18px;
    color: white;
    padding: 0 10px;
    position: relative;
    &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: rgba(214, 225, 239, 0.2);
        opacity: 0.8;
    }

    &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: rgba(214, 225, 239, 0.2);
        opacity: 0.8;
    }

    &::-ms-input-placeholder { /* Microsoft Edge */
        color: rgba(214, 225, 239, 0.2);
        opacity: 0.8;
    }
    &:focus {
        & + div > svg{
            opacity: 1;
        }
    }
`;

export const SearchBarContainer = styled.div`
    width: 100%;
    height: 50px; 
    margin: 0px 10px;
    position: relative;
`;

export const IconSearch = styled.div`
    position: absolute;
    right: 15px;
    top: 7px;
    & > svg{
            opacity: 0.4;
            transition: all 0.7s;
    }
`;

export const ContainerBreadcrumbs = styled.div`
    width: 100%;
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-decoration-line: underline;
    color: #D6E1EF;
    opacity: 0.8;
    margin-bottom: 20px;
`;

export const ContainerLoader = styled.div`
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
`;